module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Light-2962821a.svg";